<ng-container *ngIf="data.fields.Title.value !== ''">
  <div mat-dialog-title>
    <span class="dialog-title-label" *scText="data.fields.Title"></span>
    <button
      *ngIf="data.fields.HasCloseButtonInHeader.value"
      (click)="dialogRef.close()"
      class="btn btn-default"
    >
      <i class="icon-close"></i>
    </button>
  </div>
</ng-container>

<div mat-dialog-content>
  <form [formGroup]="uploadForm">
    <div class="row">
      <div class="col-sm-6">
        <div class="form-group">
          <label *scText="data.fields.DocumentTypeLabel"></label>

          <mat-form-field class="d-block ab-select" [floatLabel]="'never'" hideRequiredMarker>
            <mat-select formControlName="documentType">
              <mat-option
                *ngFor="let documentType of data.fields.DocumentType"
                [value]="documentType.fields.Value.value"
              >
                {{ documentType.fields.Label.value }}</mat-option
              >
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </div>

    <div class="row" *ngIf="showDocumentSubType">
      <div class="col-sm-4">
        <div class="form-group">
          <mat-form-field class="d-block ab-select" [floatLabel]="'never'" hideRequiredMarker>
            <mat-select
              formControlName="documentSubType"
              [placeholder]="data.fields.DocumentSubTypePlaceholder.value"
            >
              <mat-option
                *ngFor="let documentSubType of data.fields.DocumentSubType"
                [value]="documentSubType.fields.Value.value"
              >
                {{ documentSubType.fields.Label.value }}</mat-option
              >
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <div class="col-sm-4">
        <div class="form-group">
          <input
            class="form-control"
            formControlName="documentNumber"
            [placeholder]="data.fields.DocumentNumberLabel.value"
            [maxlength]="maxIdLenght"
            [pattern]="allowedIdCardCharactersRegex"
          />
          <span
            class="field-validation-error"
            *ngIf="documentNumber.errors?.maxlength"
            >{{
              formFields.genericErrors.validationInvalidMaxLength.message
            }}</span
          >
          <span
            class="field-validation-error"
            *ngIf="documentNumber.errors?.pattern"
            >{{
              formFields.genericErrors.validationInvalidPattern.message
            }}</span
          >
          <span
            class="field-validation-error"
            *ngIf="documentNumber.errors?.required"
            >{{ formFields.genericErrors.validationRequired.message }}</span
          >
        </div>
      </div>

      <div class="col-sm-4">
        <div class="form-group">
          <div
            class="ab-datepicker"
            [ngClass]="{
              'ng-dirty': expirationDate.dirty,
              'ng-invalid': expirationDate.errors,
              'ng-touched': expirationDate.touched
            }"
          >
            <div class="flex-grow-1">
              <input
                class="form-control"
                abDateFormatter
                [matDatepicker]="picker"
                [min]="expirationDateMin"
                [placeholder]="data.fields.DocumentExpirationLabel.value"
                formControlName="expirationDate"
              />
            </div>
            <button class="btn btn-default" (click)="picker.open()">
              <i class="icon-calendar"></i>
            </button>
            <mat-datepicker #picker></mat-datepicker>
          </div>
          <span
            class="field-validation-error"
            *ngIf="expirationDate.errors?.required"
            >{{ formFields.genericErrors.validationRequired.message }}</span
          >
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-12">
        <input
          formControlName="files"
          (change)="onFilesSelect($event)"
          #file
          multiple
          type="file"
          class="form-control file-upload"
        />
        <div
          abFileDropZone
          (filesChangeEmiter)="onFilesDrop($event)"
          class="drop-zone"
          (dragover)="onDragOver($event)"
          (dragleave)="onDragLeave($event)"
          (drop)="onDrop($event)"
        >
          <label class="drag-file-label">
            <div *ngIf="!isInTheZone">
              <i class="icon-plus icon-plus-upload-documents"></i>
              <span *scText="data.fields.DragFileLabel"></span>
              <span>&nbsp;</span>
              <a
                (click)="openUploadWindow($event)"
                href="#"
                *scText="data.fields.DragFileLinkLabel"
              ></a>
            </div>
            <div *ngIf="isInTheZone">
              <span
                class="drop-file-label"
                *scText="data.fields.AddFile"
              ></span>
            </div>
          </label>

          <div class="dropzone-list">
            <div class="card-deck">
              <div
                class="card"
                *ngFor="let file of fileList; let i = index"
                [ngClass]="{
                  'card-valid': validateFile(file),
                  'card-invalid': !validateFile(file)
                }"
              >
                <i
                  [matTooltip]="file.name"
                  matTooltipClass="info-tooltip"
                  class="file-preview-icon icon-copy-transfer"
                ></i>

                <div class="card-body "></div>
                <div class="card-footer text-center">
                  <small class="strong">{{ file.size | abFileSize }}</small>
                  <br />
                  <button
                    *scText="data.fields.RemoveLabel"
                    (click)="removeFile(i)"
                    class="btn btn-primary align-self-end"
                  ></button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
  <div class="errors-wrapper">
    <div
      [ngClass]="{
        'error-active': !isFilesExtensionsCorrect,
        'error-inactive': isFilesExtensionsCorrect && !initialState,
        'initial-state': initialState
      }"
    >
      <ng-container *ngIf="!isFilesExtensionsCorrect">
        <i class="icon-warning right-padding-icon"></i>
      </ng-container>
      <ng-container *ngIf="isFilesExtensionsCorrect && !initialState">
        <i class="icon-checkmark right-padding-icon"></i>
      </ng-container>
      <span *scText="data.fields.SupportedFileTypesLabel"></span>
    </div>
    <div
      [ngClass]="{
        'error-active': !isFilesSizesCorrect,
        'error-inactive': isFilesSizesCorrect && !initialState,
        'initial-state': initialState
      }"
    >
      <ng-container *ngIf="!isFilesSizesCorrect">
        <i class="icon-warning right-padding-icon"></i>
      </ng-container>
      <ng-container *ngIf="isFilesSizesCorrect && !initialState">
        <i class="icon-checkmark right-padding-icon"></i>
      </ng-container>
      <span *scText="data.fields.MaximumSizeOfFileLabel"></span>
    </div>
    <div
      [ngClass]="{
        'error-active': isMaxFileCountReached,
        'error-inactive': !isMaxFileCountReached && !initialState,
        'initial-state': initialState
      }"
    >
      <ng-container *ngIf="isMaxFileCountReached">
        <i class="icon-warning right-padding-icon"></i>
      </ng-container>
      <ng-container *ngIf="!isMaxFileCountReached && !initialState">
        <i class="icon-checkmark right-padding-icon"></i>
      </ng-container>
      <span *scText="data.fields.MaximumNumbersOfFilesLabel"></span>
    </div>
    <div
      [ngClass]="{
        'error-active': isMaxFileNameCountReached,
        'error-inactive': !isMaxFileNameCountReached && !initialState,
        'initial-state': initialState
      }"
    >
      <ng-container *ngIf="isMaxFileNameCountReached">
        <i class="icon-warning right-padding-icon"></i>
      </ng-container>
      <ng-container *ngIf="!isMaxFileNameCountReached && !initialState">
        <i class="icon-checkmark right-padding-icon"></i>
      </ng-container>
      <span *scText="data.fields.maxFileNameAndExtensionSizeLabel"></span>
    </div>
  </div>
</div>

<div mat-dialog-actions class="mat-dialog-actions">
  <ng-container *ngIf="data.fields.SubmitButtonLabel.value !== ''">
    <button
      class="btn btn-primary btn-mid btn-block btn-md-block-none"
      [disabled]="
        uploadForm.invalid ||
        !fileList.length ||
        !isFilesExtensionsCorrect ||
        !isFilesSizesCorrect ||
        isMaxFileNameCountReached
      "
      (click)="submit()"
      abButtonLoader
    >
      <span *scText="data.fields.SubmitButtonLabel"></span>
    </button>
  </ng-container>
  <ng-container *ngIf="data.fields.ClearButtonLabel.value !== ''">
    <button
      class="btn btn-outline-primary btn-mid btn-block btn-md-block-none"
      *scText="data.fields.ClearButtonLabel"
      (click)="removeFiles()"
    ></button>
  </ng-container>
  <ng-container *ngIf="data.fields.CancelButtonLabel.value !== ''">
    <button
      class="btn btn-link btn-with-icon btn-block btn-md-block-none"
      (click)="dialogRef.close(false)"
    >
      <span *scText="data.fields.CancelButtonLabel"></span>
    </button>
  </ng-container>
</div>
